import GLightbox from "glightbox";

window.lightbox = GLightbox({
  touchNavigation: true,
  loop: true,
  youtube: {
    noCookie: true,
    rel: 0,
    showinfo: 0,
    iv_load_policy: 3,
  },
  vimeo: {
    byline: false,
    portrait: false,
    title: false,
    speed: true,
    transparent: false,
  },
});
